var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export default function TravelIcon() {
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 14 14", fill: "none" }, { children: _jsx("path", { d: "M4.66665 13.6667V12.6667L5.99998 11.6667V8L0.333313 9.66667V8.33333L5.99998 5V1.33333C5.99998 1.05555 6.0972 0.819443 6.29165 0.624999C6.48609 0.430554 6.7222 0.333332 6.99998 0.333332C7.27776 0.333332 7.51387 0.430554 7.70831 0.624999C7.90276 0.819443 7.99998 1.05555 7.99998 1.33333V5L13.6666 8.33333V9.66667L7.99998 8V11.6667L9.33331 12.6667V13.6667L6.99998 13L4.66665 13.6667Z", fill: "#2B3737" }) })));
}
